<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <div class="page-wrapper" ref="formContainer">
      <!-- Page Content -->
      <div class="content container-fluid pb-0">
        <breadcrumb
          :title="title"
          :path="path"
          :text="text"
          :pathURL="'/employees'"
        />
        <profilehead
          :employeeData="employeeData"
          @set-emp-data="setEmployee"
          :hasEditPermission="hasEditPermission"
        />
        <div class="card tab-box">
          <div class="row user-tabs">
            <div class="col-lg-12 col-md-12 col-sm-12 line-tabs">
              <ul class="nav nav-tabs nav-tabs-bottom pt-3 pb-2">
                <li class="nav-item">
                  <a
                    @click="setActiveTab('emp_profile')"
                    href="#emp_profile"
                    data-bs-toggle="tab"
                    class="nav-link"
                    :class="{ active: activeTab == 'emp_profile' }"
                    >Profile</a
                  >
                </li>
                <!-- <li class="nav-item">
                  <a
                    @click="setActiveTab('emp_projects')"
                    href="#emp_projects"
                    data-bs-toggle="tab"
                    class="nav-link"
                    :class="{ active: activeTab == 'emp_projects' }"
                    >Projects</a
                  >
                </li> -->
                <li class="nav-item">
                  <a
                    v-if="
                      user_role &&
                      user_role.includes('Administrative / Super Admin')
                    "
                    @click="setActiveTab('bank_statutory')"
                    href="#bank_statutory"
                    data-bs-toggle="tab"
                    class="nav-link"
                    :class="{ active: activeTab == 'bank_statutory' }"
                    >Payroll Details
                    <small class="text-danger">(Admin Only)</small></a
                  >
                </li>
                <li class="nav-item">
                  <a
                    @click="setActiveTab('emp_assets')"
                    href="#emp_assets"
                    data-bs-toggle="tab"
                    class="nav-link"
                    :class="{ active: activeTab == 'emp_assets' }"
                    >Assets</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    @click="setActiveTab('incident')"
                    href="#emp_incident"
                    data-bs-toggle="tab"
                    class="nav-link"
                    :class="{ active: activeTab == 'incident' }"
                    >Incident</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    @click="setActiveTab('bvg')"
                    href="#emp_bvg"
                    data-bs-toggle="tab"
                    class="nav-link"
                    :class="{ active: activeTab == 'bvg' }"
                    >BGV</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    @click="setActiveTab('userOffices')"
                    href="#userOffices"
                    data-bs-toggle="tab"
                    class="nav-link"
                    :class="{ active: activeTab == 'userOffices' }"
                    >Office Location</a
                  >
                </li>
                <li class="nav-item" v-if="allowFaceTab">
                  <a
                    @click="setActiveTab('userFaceRecognization')"
                    href="#userFaceRecognization"
                    data-bs-toggle="tab"
                    class="nav-link"
                    :class="{ active: activeTab == 'userFaceRecognization' }"
                    >Face Recognization</a
                  >
                </li>
                <li class="nav-item" v-if="tablestatus == 1">
                  <a
                    @click="setActiveTab('userJobInformation')"
                    href="#userJobInformation"
                    data-bs-toggle="tab"
                    class="nav-link"
                    :class="{ active: activeTab == 'userJobInformation' }"
                    >Job Information</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="tab-content">
          <profiletab
            :employeeData="employeeData"
			:fields="allfields"
			:uifields="uifields"
			:tablestatus="tablestatus"
			:uitablestatus="uitablestatus"
            @reload-data="fetchEmp"
            @set-emp-data="setEmployee"
            :hasEditPermission="hasEditPermission"
            :hasDeletePermission="hasDeletePermission"
		  />
          <projectstab :employeeID="employeeData?.id" />
          <banktab :employeeData="employeeData" />
          <profileassets
            :employeeID="employeeData?.id"
            :activeTab="activeTab"
          />
          <emp-incident :employeeID="employeeData?.id" :activeTab="activeTab" />
          <emp-bvg :employeeID="employeeData?.id" :activeTab="activeTab" />
          <emp-office
            :employeeID="employeeData?.id"
            :employeeData="employeeData"
            :activeTab="activeTab"
            @reload-data="fetchEmp"
          />
          <emp-face-recognization
            :employeeID="employeeData?.id"
            :employeeData="employeeData"
            :activeTab="activeTab"
            @reload-data="fetchEmp"
          />
          <emp-job-information
            :employeeID="employeeData?.id"
            :employeeData="employeeData"
            :userInformationFields="userInformationFields"
            :userInformationFormData="userInformationFormData"
            :activeTab="activeTab"
            @reload-data="fetchEmp"
			@load-fields="loadUserFields"
			v-if="tablestatus == 1"
          />
        </div>
      </div>
      <profilemodal :employeeData="employeeData" @reload-data="fetchEmp" :fields="allfields" :uifields="uifields" :uitablestatus="uitablestatus" />
      <employee-edit-model
        :employeeData="employeeData"
        @reload-data="fetchEmp"
      ></employee-edit-model>
    </div>
  </div>
</template>
<script>
import { notification } from "ant-design-vue";
import axios from "axios";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
export default {
  name: "profile",
  data() {
    return {
      title: "Profile",
      path: "Employee",
      text: "Profile",
      employeeData: null,
      empData: null,
      activeTab: "emp_profile",
      hasReadPermission: null,
      hasEditPermission: true,
      hasCreatePermission: true,
      hasDeletePermission: true,
      user_role: "",
      userInformationFields: [],
      userInformationFormData: {},
	  allfields: {},
	  uifields: {},
	  tablestatus: 0,
	  uitablestatus: 0,
    };
  },
  methods: {
    ...mapActions(["fetchEmployeeProfileData"]),
    async fetchEmp() {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      try {
        const data = await this.fetchEmployeeProfileData(
          this.$route.params.user_id
        );
        this.employeeData = null;
        this.empData = null;
        this.$nextTick(() => {
          this.employeeData = data;
          this.empData = data;
        });
      } catch (error) {
        console.error("Error fetching employee data:", error);
      } finally {
        loader.hide();
      }
	  
	  this.loadUserAllFields();
	  
    },
    setEmployee() {
      this.employeeData = null;
      this.$nextTick(() => {
        this.employeeData = this.empData;
      });
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },
	getFields(tabSlug, section = "default"){
		return allfields.value?.[tabSlug]?.[section] || [];
	},
	loadFieldWithStatus(){
		
		var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

	  axios
        .get("/uifields/list", {
		params: {
		  page: 'profile',  // send as query param
		},
	  }).then((response) => {
	  
		  console.log("all fields status");
          this.uifields = response.data?.data || {};
          this.uitablestatus = response.data?.tableexists || 0;
		  
		  console.log("ui fields");
		  
		  console.log(this.uifields);
		  

       }).catch((error) => {
	   
          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
		  
        });
	},
	loadUserAllFields(){
		
	  console.log("all fields called");
      
	  var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

	  var user_id = this?.$route?.params?.user_id || "";
	  
      axios
        .get("/userfields/allfields", {
		params: {
		  employee_id: user_id,  // send as query param
		},
	  }).then((response) => {
	  
		  console.log("all fields data");
          console.log(response.data);
		  
		  this.allfields = response.data.tabs || {};
		  this.tablestatus = response.data.tableexists || 0;

       }).catch((error) => {
	   
          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
		  
        });
	  
	},
    loadUserFields(tab) {
      console.log("tab called");
      console.log(tab);

      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

	  var user_id = this?.$route?.params?.user_id || "";
	  
      axios
        .get("/fields/userJobInformation", {
		params: {
		  employee_id: user_id,  // send as query param
		},
	  }).then((response) => {
          console.log(response.data);

          this.userInformationFields = response.data.fields;

          // prefill form data
          response.data.fields.forEach((f) => {
            this.userInformationFormData[f.slug] = f.value || "";
          });
        })
        .catch((error) => {
		
          /*var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }*/
		  
        });
    },
  },
  watch: {
    "$route.params.user_id": function (newParamValue, oldParamValue) {
      this.fetchEmp();
    },
  },
  async created() {
    var user = JSON.parse(window.localStorage.getItem("user"));
    const route = Number(this.$route.params.user_id);
    this.user_role = window.localStorage.getItem("role");

    if (user.id !== route) {
      this.$store
        .dispatch("userPermissions", { module: "employee", action: "read" })
        .then((response) => {
          this.hasReadPermission = null;
          this.$nextTick(() => {
            this.hasReadPermission = response === "true";

            if (!this.hasReadPermission) {
              notification.open({
                message: "You don't have access to this page!",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });

              if (this.user_role && this.user_role.includes("Employee")) {
                this.$router
                  .push({ name: "employee-dashboard" })
                  .catch((error) => {});
              } else {
                this.$router
                  .push({ name: "admin-dashboard" })
                  .catch((error) => {});
              }
            }
          });
        });
    }

    if (user.id !== route) {
      this.$store
        .dispatch("userPermissions", { module: "employee", action: "write" })
        .then((response) => {
          this.hasEditPermission = null;
          this.$nextTick(() => {
            this.hasEditPermission = response === "true";
          });
        });
    }

    if (user.id !== route) {
      this.$store
        .dispatch("userPermissions", { module: "employee", action: "create" })
        .then((response) => {
          this.hasCreatePermission = null;
          this.$nextTick(() => {
            this.hasCreatePermission = response === "true";
          });
        });
    }

    if (user.id !== route) {
      this.$store
        .dispatch("userPermissions", { module: "employee", action: "delete" })
        .then((response) => {
          this.hasDeletePermission = null;
          this.$nextTick(() => {
            this.hasDeletePermission = response === "true";
          });
        });
    }

    this.fetchEmp();

    this.loadUserFields("userJobInformation");
	
	this.loadUserAllFields();
	this.loadFieldWithStatus();
  },
  computed: {
    allowFaceTab() {
      let role = localStorage.getItem("role") || null;

      if (typeof role === "string") {
        if (
          role == "HR" ||
          role == "Administrative / Super Admin" ||
          role == "Employee"
        ) {
          return true;
        }

        return false;
      } else if (Array.isArray(role)) {
        if (
          role.includes("HR") ||
          role.includes("Administrative / Super Admin") ||
          role.includes("Employee")
        ) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
  },
};
</script>
